import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_COMMON_URL } from "../constants/constants";

import { billingEndpoints } from "./endpoints/billing.endpoints";
import { productsEndpoints } from "./endpoints/products.endpoints";

export const baseApi = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: API_COMMON_URL,
    }),
    endpoints: (builder) => ({
        ...billingEndpoints(builder),
        ...productsEndpoints(builder),
    }),
});

export const {
    useGetProductTariffsQuery,
    useBillPackagePayQuery,
    useBillCheckoutMutation,
} = baseApi;
